import React from "react";
import { motion } from "framer-motion";
import {
  Home,
  Building2,
  KeyRound,
  Archive,
  Sofa,
  TreeDeciduous,
  Hammer,
  ArrowUpRight,
} from "lucide-react";
import { SERVICES, BUSINESS } from "../../lib/constants";

const ICONS = {
  Home,
  Building2,
  KeyRound,
  Archive,
  Sofa,
  TreeDeciduous,
  Hammer,
};

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="bg-white py-24 sm:py-32 border-b-2 border-navy"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <span className="label-pill">
              <span className="h-1.5 w-1.5 bg-gold" />
              01 — What we haul
            </span>
            <h2 className="font-display uppercase text-navy text-4xl sm:text-5xl lg:text-6xl mt-5 leading-[0.95] max-w-3xl">
              Services we <span className="text-gold">offer.</span>
            </h2>
          </div>
          <p className="font-body text-navy/70 max-w-md text-base sm:text-lg">
            From one old couch to a full demo job — our crew shows up on time,
            works hard, and leaves your space spotless.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0 border-2 border-navy">
          {SERVICES.map((svc, idx) => {
            const Icon = ICONS[svc.icon];
            const isLastRowCol =
              idx === SERVICES.length - 1 && SERVICES.length % 3 !== 0;
            return (
              <motion.a
                href="#quote"
                key={svc.key}
                data-testid={`service-card-${svc.key}`}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.4, delay: idx * 0.05 }}
                className={`group relative p-8 sm:p-10 bg-white hover:bg-navy transition-colors duration-300 border-navy ${
                  idx % 3 !== 2 ? "lg:border-r-2" : ""
                } ${idx % 2 !== 1 ? "md:border-r-2 lg:border-r-2" : "md:border-r-0"} ${
                  idx < SERVICES.length - (SERVICES.length % 3 || 3)
                    ? "lg:border-b-2"
                    : ""
                } ${
                  idx < SERVICES.length - 1 ? "border-b-2 md:border-b-2" : ""
                } ${isLastRowCol ? "lg:col-span-3" : ""}`}
              >
                <div className="flex items-start justify-between mb-8">
                  <div className="h-16 w-16 flex items-center justify-center bg-gold text-navy border-2 border-navy group-hover:bg-white group-hover:border-white transition-colors">
                    {Icon && <Icon className="h-8 w-8" strokeWidth={2.5} />}
                  </div>
                  <ArrowUpRight
                    className="h-6 w-6 text-navy group-hover:text-gold transition-colors"
                    strokeWidth={2.5}
                  />
                </div>
                <h3 className="font-display uppercase text-2xl sm:text-3xl text-navy group-hover:text-white transition-colors leading-tight">
                  {svc.title}
                </h3>
                <p className="mt-4 font-body text-navy/75 group-hover:text-white/80 transition-colors text-base leading-relaxed">
                  {svc.desc}
                </p>
              </motion.a>
            );
          })}
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 p-6 border-2 border-navy bg-offwhite">
          <p className="font-display uppercase text-navy text-lg sm:text-xl">
            Not sure what you need? We'll walk the job with you — free.
          </p>
          <a
            href={BUSINESS.phoneHref}
            data-testid="services-call-btn"
            className="brutal-btn inline-flex items-center gap-2 bg-navy text-white px-6 py-3 font-display text-sm uppercase tracking-wider border-2 border-navy shrink-0"
          >
            Call {BUSINESS.phoneDisplay}
          </a>
        </div>
      </div>
    </section>
  );
};
